import { VAlert } from 'vuetify/lib/components/VAlert';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import Ripple from 'vuetify/lib/directives/ripple';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "text-center" },
    [
      !_vm.loading
        ? _c(
            "div",
            [
              _vm.eventSummary && _vm.eventSummary.count > 0
                ? _c(
                    VSheet,
                    {
                      directives: [{ def: Ripple, name: "ripple", rawName: "v-ripple" }],
                      staticClass: "d-flex justify-center pa-3",
                      attrs: { elevation: 1, color: _vm.color },
                      on: {
                        click: function ($event) {
                          _vm.hoverShow = false
                          _vm.$emit("clickViewDetails")
                        },
                      },
                    },
                    [
                      _c(
                        VMenu,
                        {
                          attrs: {
                            "open-on-hover": "",
                            auto: "",
                            "offset-y": "",
                            "offset-x": "",
                            "close-on-click": "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on, attrs }) {
                                  return [
                                    _c(
                                      "div",
                                      _vm._g(
                                        _vm._b({}, "div", attrs, false),
                                        on
                                      ),
                                      [
                                        _vm.display == "index"
                                          ? _c("span", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.eventSummary.index
                                                  ) +
                                                  " "
                                              ),
                                            ])
                                          : _vm._e(),
                                        _vm.display == "value" ||
                                        _vm.display == "value-quantity"
                                          ? _c("span", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f("currency")(
                                                      _vm.eventSummary
                                                        .totalValue
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ])
                                          : _vm._e(),
                                        _vm.display == "quantity" ||
                                        _vm.display == "value-quantity"
                                          ? _c(
                                              "span",
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm._f("formatNumber")(
                                                        _vm.eventSummary
                                                          .totalQuantity
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                                _vm.eventSummary.hasAdjustment
                                                  ? _c(
                                                      VIcon,
                                                      {
                                                        attrs: {
                                                          small: "",
                                                          color: "red darken-2",
                                                        },
                                                      },
                                                      [_vm._v(" mdi-alert ")]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2388246175
                          ),
                          model: {
                            value: _vm.hoverShow,
                            callback: function ($$v) {
                              _vm.hoverShow = $$v
                            },
                            expression: "hoverShow",
                          },
                        },
                        [
                          _c(
                            VList,
                            [
                              _vm.eventSummary.hasAdjustment
                                ? _c(
                                    VAlert,
                                    { attrs: { type: "warning" } },
                                    [_vm._v(" Contains adjustments ")]
                                  )
                                : _vm._e(),
                              _c(VSimpleTable, { attrs: { dense: "" } }, [
                                _c("tbody", [
                                  _c("tr", [
                                    _c("td", [_vm._v("Date")]),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatDate")(
                                            _vm.dateRange.startTime
                                          )
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _c("tr", [
                                    _c("td", [_vm._v("Product")]),
                                    _c("td", [
                                      _vm._v(_vm._s(_vm.product.name)),
                                    ]),
                                  ]),
                                  _c("tr", [
                                    _c("td", [_vm._v("Count")]),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(_vm.eventSummary.count) +
                                          " events"
                                      ),
                                    ]),
                                  ]),
                                  _c("tr", [
                                    _c("td", [_vm._v("Net Value")]),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("currency")(
                                            _vm.eventSummary.totalValue
                                          )
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _c("tr", [
                                    _c("td", [_vm._v("Net Quantity")]),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatNumber")(
                                            _vm.eventSummary.totalQuantity
                                          )
                                        )
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _c(VProgressCircular, {
            attrs: { width: 3, color: "primary", indeterminate: "" },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }